export default __webpack_public_path__ + "static/media/non-hazardous.ee853db2.png";